export default "__VITE_ASSET__BCX0qCZp__"